import styled from 'styled-components'
import { mediaQueries } from '@blazar-plugins/device'
/**
 * css used by ::before and ::after to make
 * sure underlying fullscreen scroll ad does
 * not leak on scroll
 */
const clear = `
  z-index: 2;
  position: absolute;
  height: 150vh;
  width: 100vw;
  display: block;
  content: '';
  background-color: #fff;
`
export const DummyComponent = styled.div`
  height: 0;
  @media ${mediaQueries.medium} {
    height: ${(props) => (props.isWallpaper ? '240px' : '0px')};
  }
`

const StyledAppNexusPlacement = styled.div`
  .cogwheel {
    display: none;
    position: ${(props) => (props.fullscreen ? 'sticky' : 'absolute')};
    ${(props) => (props.fullscreen ? 'left: 100%;' : '')}
    z-index: 1;
    right: 0;
    top: 0;
    height: 26px;
    width: 26px;
    opacity: 0.7;
    background-color: rgba(255, 255, 255, 0.7);
  }

  &.creative-loaded .cogwheel {
    display: block;
  }

  &.disable-cogwheel .cogwheel {
    display: none;
  }

  &.standard {
    display: flex;
    position: relative;
    justify-content: center;
    &.creative-unavailable {
      display: none;
    }
  }

  &.wallpaper {
    position: absolute;
    overflow: hidden;
    top: 0;
    left: -100%;
    right: -100%;
    margin: 0 auto;
    width: 100vw;
    background-color: transparent;
  }

  &.fullscreen {
    position: relative;
    visibility: ${(props) => (props.inScreen ? 'visible' : 'hidden')};

    &:before {
      top: -150vh;
      ${clear}
    }

    &:after {
      top: 100vh;
      ${clear}
    }

    #div_utif_${(props) => props.id} {
      top: 0 !important;
      left: 0 !important;
      height: 100vh !important;
      width: 100vw !important;
      position: fixed !important;
      transform: translate3d(0, 0, 0) !important;
      overflow: hidden !important;
      z-index: 0 !important;

      iframe {
        height: inherit !important;
        width: inherit !important;
      }
    }
  }
`

export default StyledAppNexusPlacement
